var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback } from 'react';
import { TextInput } from '../TextInput';
import { inputMasks } from '../../../utils/inputMasks.utils';
import { getTranslation } from '../../../utils/translations';
import translations from './translations';
import helpers from './helpers';
import { useMVVM, } from '../../../hooks/useMVVM.hook';
import { DATEPICKER_FORMATS } from './types';
var t = getTranslation(translations);
export function Datepicker(props) {
    var _a = props.format, format = _a === void 0 ? DATEPICKER_FORMATS.MM_YYYY : _a;
    var mapModelToView = useCallback(function (modelValue, lastViewValue) {
        if (typeof modelValue === 'undefined') {
            return '';
        }
        if (modelValue === null) {
            return lastViewValue || '';
        }
        return helpers.makeInputStringFromISOString(modelValue, format);
    }, [format]);
    var mapViewToModel = useCallback(function (viewValue) {
        if (viewValue.length === 0) {
            return undefined;
        }
        return helpers.makeISOStringFromInputString(viewValue, format);
    }, [format]);
    var mappedMVVMProps = useMVVM(__assign(__assign({}, props), { value: props.value, defaultViewValue: '', mapViewToModel: mapViewToModel, mapModelToView: mapModelToView }));
    var placeholder = format === DATEPICKER_FORMATS.MM_YYYY
        ? t.mm_yyyy_placeholder
        : t.dd_mm_yyyy_placeholder;
    return (React.createElement(TextInput, __assign({}, props, mappedMVVMProps, { placeholder: placeholder, mask: inputMasks.getDateMask(format), placeholderChar: "_" })));
}
